<template>
  <div class="g-modal" v-if="request.id">
    <div class="g-content">
      <div class="header p-3">
        <h4 class="m-0">کنسل کردن درخواست بار</h4>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <div class="p-3">
        <div class="description d-flex align-items-center mb-2">
          <i class="fas fa-exclamation-triangle"></i>
          <h4 class="mr-2 pt-1">
            {{ description }}
          </h4>
        </div>
        <div class="mb-2">
          از مبدأ
          {{ originText }}
          به مقصد
          {{ destinationText }}
        </div>

        <div class="mb-3">
          شماره پیگیری
          {{ request.tracking_code || "-" }}
        </div>
        <div class="d-flex">
          <bita-bootbutton v-if="!propsSilver" class="ml-1 w-100" type="danger" title="همه ی بارها" data-dismiss="modal"
            @click.native="cancelRequest('all')" />
          <bita-bootbutton class="mr-1 w-100" type="danger" title="فقط بارهای آزاد" data-dismiss="modal"
            @click.native="cancelRequest('free')" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isLoadingSendData: false,
      request: {},
    };
  },
  props: {
    propsSilver: {
      type: Boolean,
    },
  },
  computed: {
    originText() {
      const origin = this.request && this.request.origin;

      if (origin) {
        const parts = [
          origin.province && origin.province.name,
          origin.name,
        ].filter(Boolean);

        if (parts.length) {
          return parts.join(" / ");
        }
      }

      return (this.request && this.request.origin_name) || "-";
    },

    destinationText() {
      const destination = this.request && this.request.destination;

      if (destination) {
        const parts = [
          destination.province && destination.province.name,
          destination.name,
        ].filter(Boolean);

        if (parts.length) {
          return parts.join(" / ");
        }
      }

      return (this.request && this.request.destination_name) || "-";
    },
    description() {
      return "آیا از کنسل کردن درخواست بار خود اطمینان دارید؟";
    },
  },
  methods: {
    closeModal() {
      this.request = {};
    },
    init(_request) {
      this.request = _request;
    },
    cancelRequest(type) {
      this.$emit("on-submit", { request: this.request, type });

      this.closeModal();
    },
  },
};
</script>

<style lang="scss" scoped>
.g-modal {
  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;

  .g-content {
    background-color: #fff;
    border-radius: 4px;
    max-height: 460px;
    height: auto;
    max-width: 400px;
    width: 100%;

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
    }

    .description {
      color: rgb(237, 85, 101);
    }
  }
}
</style>
